// TODO: En el futuro cambiar por servicio de traducción y quitar esto
const DESCRIPTION_LAYER_ARRAY = [
  {
    layerId: 'SalidaDeAutopista',
    description: 'Salida de autopista',
  },
  {
    layerId: 'NumeroDeSalida',
    description: 'Número de salida',
  },
  {
    layerId: 'MarcadorSalidaAutopista',
    description: 'Marcador salida de autopista',
  },
  {
    layerId: 'NudoDeCarretera',
    description: 'Nudo de carretera',
  },
  {
    layerId: 'NombreDeSalida',
    description: 'Nombre de salida',
  },
  {
    layerId: 'DenominacionEuropea',
    description: 'Denominación europea',
  },
  {
    layerId: 'NombreDeAutopista',
    description: 'Nombre de autopista',
  },
  {
    layerId: 'AreasDeServicio',
    description: 'Áreas de servicio',
  },
  {
    layerId: 'AutopistaDePeaje',
    description: 'Autopista de peaje',
  },
  {
    layerId: 'AutopistasDePeajeEnConstruccion',
    description: 'Autopistas de peaje en construcción',
  },
  {
    layerId: 'AutopistaInterna',
    description: 'Autopista interna',
  },
  {
    layerId: 'AutopistaLibreAutovia',
    description: 'Autopista libre / Autovía',
  },
  {
    layerId: 'AutopistaLibreAutoviaEnConstruccion',
    description: 'Autopista libre / Autovía en construcción',
  },
  {
    layerId: 'Multicarril',
    description: 'Multicarril',
  },
  {
    layerId: 'MulticarrilEnConstruccion',
    description: 'Multicarril en construccion',
  },
  {
    layerId: 'NombreDeCarreteraEstatal',
    description: 'Nombre de carretera estatal',
  },
  {
    layerId: 'CarreteraDelEstado',
    description: 'Carretera del estado',
  },
  {
    layerId: 'CarreteraDelEstadoEnConstruccion',
    description: 'Carretera del estado en construcción',
  },
  {
    layerId: 'NombreCarreteraAutonomica1Orden',
    description: 'Nombre de carretera autonómica 1.ᵉʳ orden',
  },
  {
    layerId: 'NombreCarreteraAutonomica2Orden',
    description: 'Nombre de carretera autonómica de 2.º orden',
  },
  {
    layerId: 'NombreCarreteraAutonomica3Orden',
    description: 'Nombre de carretera autonómica de 3.ᵉʳ orden',
  },
  {
    layerId: 'AutonomicaDe1Orden',
    description: 'Autonómica de 1.ᵉʳ orden',
  },
  {
    layerId: 'AutonomicaDe1OrdenEnConstruccion',
    description: 'Autonómica de 1.ᵉʳ orden en construcción',
  },
  {
    layerId: 'AutonomicaDe2Orden',
    description: 'Autonómica de 2.º orden',
  },
  {
    layerId: 'AutonomicaDe2OrdenEnConstruccion',
    description: 'Autonómica de 2.º orden en construcción',
  },
  {
    layerId: 'AutonomicaDe3Orden',
    description: 'Autonómica de 3.ᵉʳ orden',
  },
  {
    layerId: 'AutonomicaDe3OrdenEnConstruccion',
    description: 'Autonómica de 3.ᵉʳ orden en construcción',
  },
  {
    layerId: 'RedUrbana',
    description: 'Red urbana',
  },
  {
    layerId: 'OtrasCarreteras',
    description: 'Otras carreteras',
  },
  {
    layerId: 'NumeroDePK',
    description: 'Número de PK',
  },
  {
    layerId: 'DistanciaParcialMenor',
    description: 'Distancia parcial menor',
  },
  {
    layerId: 'DistanciaParcialMayor',
    description: 'Distancia parcial mayor',
  },
  {
    layerId: 'DistanciaParcialEnAutopista',
    description: 'Distancia parcial en autopista',
  },
  {
    layerId: 'Pks',
    description: 'Pks',
  },
  {
    layerId: 'IndicadorDistanciaParcialAutopistas',
    description: 'Indicador distancia parcial autopistas',
  },
  {
    layerId: 'IndicadorDistanciaParcialMayor',
    description: 'Indicador distancia parcial mayor',
  },
  {
    layerId: 'IndicadorDistanciaParcialMenor',
    description: 'Indicador distancia parcial menor',
  },
  {
    layerId: 'NombreDePuertoDeMontana',
    description: 'Nombre de puerto de montaña',
  },
  {
    layerId: 'GranPuertoDeMontana',
    description: 'Gran puerto de montaña',
  },
  {
    layerId: 'PuertosDeMontanaConProblemasDeNieve',
    description: 'Puertos de montaña con problemas de nieve',
  },
  {
    layerId: 'PuertosDeMontanaSinProblemasDeNieve',
    description: 'Puertos de montaña sin problemas de nieve',
  },
  {
    layerId: 'AVE',
    description: 'AVE',
  },
  {
    layerId: 'TunelEnAVE',
    description: 'Túnel en AVE',
  },
  {
    layerId: 'ViaAncha',
    description: 'Vía ancha',
  },
  {
    layerId: 'TunelEnViaAncha',
    description: 'Túnel en vía ancha',
  },
  {
    layerId: 'TunelEnViaEstrecha',
    description: 'Túnel en vía estrecha',
  },
  {
    layerId: 'ViaEstrecha',
    description: 'Vía estrecha',
  },
  {
    layerId: 'NombreDeAldea',
    description: 'Nombre de aldea',
  },
  {
    layerId: 'NombreMunicipioDeMenos5000Hab',
    description: 'Nombre de municipio menor de 5.000 habitantes',
  },
  {
    layerId: 'NombreMunicipio5000a25000Hab',
    description: 'Nombre de municipio entre 5.000 y 25.000 habitantes',
  },
  {
    layerId: 'NombreMunicipioDeMasDe25000Hab',
    description: 'Nombre de municipio mayor de 25.000 habitantes',
  },
  {
    layerId: 'Aldea',
    description: 'Aldea',
  },
  {
    layerId: 'MunicipioMenorDe5000Hab',
    description: 'Municipio menor de 5.000 habitantes',
  },
  {
    layerId: 'MunicipioEntre5000y25000Hab',
    description: 'Municipio entre 5.000 y 25.000 habitantes',
  },
  {
    layerId: 'MunicipioDeMasDe25000Hab',
    description: 'Municipio de más de 25.000 habitantes',
  },
  {
    layerId: 'Tunel',
    description: 'Túnel',
  },
  {
    layerId: 'Aeropuerto',
    description: 'Aeropuerto',
  },
  {
    layerId: 'Puente',
    description: 'Puente',
  },
  {
    layerId: 'Presa',
    description: 'Presa',
  },
  {
    layerId: 'EstacionFerrocarril',
    description: 'Estación de ferrocarril',
  },
  {
    layerId: 'Faro',
    description: 'Faro',
  },
  {
    layerId: 'Monumento',
    description: 'Monumento',
  },
  {
    layerId: 'Ermita',
    description: 'Ermita',
  },
  {
    layerId: 'Balneario',
    description: 'Balneario',
  },
  {
    layerId: 'Jardin',
    description: 'Jardin',
  },
  {
    layerId: 'Ruina',
    description: 'Ruina',
  },
  {
    layerId: 'Monasterio',
    description: 'Monasterio',
  },
  {
    layerId: 'Cueva',
    description: 'Cueva',
  },
  {
    layerId: 'Castillo',
    description: 'Castillo',
  },
  {
    layerId: 'CasaRural',
    description: 'Casa rural',
  },
  {
    layerId: 'Camping',
    description: 'Camping',
  },
  {
    layerId: 'Parador',
    description: 'Parador',
  },
  {
    layerId: 'CuadroDeNombresDePlayas',
    description: 'Cuadro de nombre de playas',
  },
  {
    layerId: 'IndicadorPlaya',
    description: 'Indicador playa',
  },
  {
    layerId: 'NombrePlaya',
    description: 'Nombre de playa',
  },
  {
    layerId: 'Playas',
    description: 'Playas',
  },
  {
    layerId: 'CampoDeGolf',
    description: 'Campo de golf',
  },
  {
    layerId: 'PuertoDeportivo',
    description: 'Puerto deportivo',
  },
  {
    layerId: 'ParquesNacionales',
    description: 'Parques nacionales',
  },
  {
    layerId: 'EspaciosProtegidos',
    description: 'Espacio protegido',
  },
  {
    layerId: 'CaminoDeSantiago',
    description: 'Camino de Santiago',
  },
  {
    layerId: 'NombreDeCaminoDeSantiago',
    description: 'Nombre de Camino de Santiago',
  },
  {
    layerId: 'IndicadorCaminoDeSantiago',
    description: 'Indicador Camino de Santiago',
  },
  {
    layerId: 'CuadroDeNombreDeCaminoDeSantiago',
    description: 'Cuadro de nombre de Camino de Santiago',
  },
  {
    layerId: 'CuadroDeNombreDeCaminoDeSantiago_3857',
    description: 'Cuadro de nombre de Camino de Santiago',
  },
  {
    layerId: 'ViaVerde',
    description: 'Vías verdes/Rutas ciclistas',
  },
  {
    layerId: 'NombreDeViaVerde',
    description: 'Número de Vías verdes/Rutas ciclistas',
  },
  {
    layerId: 'NumeroRutaTuristica',
    description: 'Número de ruta turística',
  },
  {
    layerId: 'SimboloDeRutaTuristica',
    description: 'Símbolo de ruta turística',
  },
  {
    layerId: 'RutaTuristica',
    description: 'Ruta turística',
  },
  {
    layerId: 'Fotos',
    description: 'Fotos',
  },
  {
    layerId: 'Icnita',
    description: 'Icnita',
  },
  {
    layerId: 'relievePeninsula',
    description: 'Península',
  },
  {
    layerId: 'relieveCanarias',
    description: 'Canarias',
  },
];

const DESCRIPTION_LAYER_MAP = new Map(DESCRIPTION_LAYER_ARRAY.map(
  ({layerId, description, iconUrl}) => {
    return [layerId, {description, iconUrl}];
  }),
);
export function getLayerDescription(layerId) {
  return DESCRIPTION_LAYER_MAP.get(layerId)?.description;
}
